import { userConstants } from '../constants';

export function users(state = {}, action) {
  switch (action.type) {
    case userConstants.GETALL_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GETALL_SUCCESS:
      return {
        items: action.result.users,
        nbPages: action.result.nbPages,
        nbUsers: action.result.nbUsers,
        currentPage: action.result.currentPage,
        loading: false,
      };
    case userConstants.GETALL_FAILURE:
      return {
        error: action.error,
      };
    case userConstants.USER_UPDATE_REQUEST:
      return {
        updating: true,
      };
    case userConstants.USER_UPDATE_SUCCESS:
      return {
        items: action.result.users,
        nbPages: action.result.nbPages,
        nbUsers: action.result.nbUsers,
        currentPage: action.result.currentPage,
        loading: false,
        updating: false,
      };
    case userConstants.DELETE_SUCCESS:
      return {
        items: action.result.users,
        nbPages: action.result.nbPages,
        nbUsers: action.result.nbUsers,
        currentPage: action.result.currentPage,
        loading: false,
      };
    case userConstants.USER_RESET_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.reducer.js